import { useTranslation } from 'react-i18next'

import { refundTitles } from './constants'
import { Container } from './styles'

const InstantReveniHeader = ({ type }) => {
  const { t } = useTranslation()

  return (
    <Container>
      <p>{t(refundTitles?.[type])}</p>
      <img src="/logos/reveni_logo.svg" alt="reveni_logo" />
    </Container>
  )
}

export default InstantReveniHeader
